import DomainAndDomainPlatformFilter from 'redpoints-model-js/model/filter/DomainAndDomainPlatformFilter';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import TestPurchaseController from 'redpoints-restapi-connector/controller/TestPurchaseController';
import TestPurchaseDiscardedReasonController from 'redpoints-restapi-connector/controller/TestPurchaseDiscardedReasonController';

import {
  CONNECTOR_REQUEST,
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_CLEAR_FILTERS,
  TEST_PURCHASE_COMPLETE_EVIDENCE,
  TEST_PURCHASE_DELAY_LINK,
  TEST_PURCHASE_DISCARD_EVIDENCE,
  TEST_PURCHASE_FETCH_DISCARDED_REASONS,
  TEST_PURCHASE_FETCH_DOMAINS,
  TEST_PURCHASE_FETCH_LINK_INFO,
  TEST_PURCHASE_SET_EVIDENCES_URL,
  TEST_PURCHASE_SET_FILTERS_SELECTED,
} from './actionTypes';

export const testPurchaseClear = () => ({
  type: TEST_PURCHASE_CLEAR,
});

export const testPurchaseClearFilters = () => ({
  type: TEST_PURCHASE_CLEAR_FILTERS,
});

export const testPurchaseCompleteEvidence = ({
  context,
  linkId,
  evidence,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    context,
    requestType: TEST_PURCHASE_COMPLETE_EVIDENCE,
    connectorMethod: TestPurchaseController.complete,
    sortedParameters: [linkId, evidence],
    expectedStatus: HttpStatus.CREATED,
  },
});

export const testPurchaseDelayLink = ({ context, linkId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    context,
    requestType: TEST_PURCHASE_DELAY_LINK,
    connectorMethod: TestPurchaseController.delay,
    sortedParameters: [linkId],
    expectedStatus: HttpStatus.NO_CONTENT,
  },
});

export const testPurchaseDiscardEvidence = ({ context, linkId, evidence }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    context,
    requestType: TEST_PURCHASE_DISCARD_EVIDENCE,
    connectorMethod: TestPurchaseController.discard,
    sortedParameters: [linkId, evidence],
    expectedStatus: HttpStatus.CREATED,
  },
});

export const testPurchaseFetchDiscardedReasons = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: TEST_PURCHASE_FETCH_DISCARDED_REASONS,
    connectorMethod: TestPurchaseDiscardedReasonController.list,
    sortedParameters: [],
    expectedStatus: HttpStatus.OK,
  },
});

export const testPurchaseFetchDomains = ({ customerId, contractId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: TEST_PURCHASE_FETCH_DOMAINS,
    connectorMethod: TestPurchaseController.domainPlatformWithCounterList,
    sortedParameters: [customerId, contractId],
    expectedStatus: HttpStatus.OK,
  },
});

export const testPurchaseFetchLinkInfo = ({
  allDomainIds,
  contractId,
  customerId,
}) => {
  const filters = Object.assign(new DomainAndDomainPlatformFilter(), {
    contractId: contractId ?? null,
    customerId: customerId ?? null,
    domains: allDomainIds,
  });

  return {
    type: CONNECTOR_REQUEST,
    meta: {
      requestType: TEST_PURCHASE_FETCH_LINK_INFO,
      connectorMethod: TestPurchaseController.next,
      sortedParameters: [filters],
      expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND],
    },
  };
};

export const testPurchaseSetEvidencesUrl = ({ evidencesUrl }) => ({
  type: TEST_PURCHASE_SET_EVIDENCES_URL,
  payload: { evidencesUrl },
});

export const testPurchaseSetFiltersSelected = ({
  domainId,
  domainPlatformId,
  filterBy,
}) => ({
  type: TEST_PURCHASE_SET_FILTERS_SELECTED,
  payload: {
    domainId,
    domainPlatformId,
    filterBy,
  },
});
